export default __webpack_public_path__ + "static/media/quality_img-1.d282d6c6.jpg";